var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link-atom",attrs:{"href":`${_vm.href}`},on:{"click":($event) => _vm.$emit('click', $event)}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.icon)?_c('AtomsCommonAtomIcon',{attrs:{"icon":_vm.icon,"size":14}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }